import { Directive, Input } from '@angular/core';
import { AbstractControl, NG_VALIDATORS, Validator } from '@angular/forms';

@Directive({
  selector: '[payCaseInsensitiveUnique][formControlName],[payCaseInsensitiveUnique][formControl],[payCaseInsensitiveUnique][ngModel]',
  providers: [{ provide: NG_VALIDATORS, useExisting: UniqueCaseInsensitiveDirective, multi: true }]
})

export class UniqueCaseInsensitiveDirective implements Validator {

  @Input()
  payCaseInsensitiveUnique: Array<string>;

  @Input()
  payCaseInsensitiveInitialValue: string;

  validate(ctrl: AbstractControl):  { [key: string]: any } {
    if(ctrl.value == this.payCaseInsensitiveInitialValue || !ctrl.value) {
      return null;
    } else {
      return this.payCaseInsensitiveUnique.findIndex(x => x.trim().toLowerCase() == ctrl.value.trim().toLowerCase()) > -1 ?  { "payCaseInsensitiveUnique": true } : null;
    }    
  }
} 



// WEBPACK FOOTER //
// ./src/directives/unique-case-insensitive-validator.directive.ts